export const MIN_LOADING_DURATION_MS = 400

export const promoMutationCacheKey = (token: string): string => `promo-${token}`
